
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.8), rgba(59, 130, 246, 0.6)), url('https://public.readdy.ai/ai/img_res/dc9fe8eee3a5ead298866221df3b844b.jpg')`
      }}
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div className="w-full">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            <span className="block" style={{ fontFamily: '"Playfair Display", serif' }}>
              Transform Your
            </span>
            <span className="block text-teal-300">
              Financial Future
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed">
            Expert financial planning and business development services to help you achieve sustainable growth, 
            optimize your investments, and build lasting wealth through strategic financial advisory solutions.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
                variant="primary"
                size="lg"
                className="min-w-[200px]"
                onClick={() => {
                  const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
                  if (widget) {
                    widget.click();
                  }
                }}
              >
                <i className="ri-calendar-line mr-2"></i>
                Schedule Consultation
              </Button>
            <Button 
              variant="outline" 
              size="lg"
              href="#services"
              className="min-w-[200px] border-white text-white hover:bg-white hover:text-blue-600"
            >
              <i className="ri-arrow-down-line mr-2"></i>
              Explore Services
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Investment Planning</h3>
              <p className="text-blue-100">Strategic portfolio management and investment advisory services</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Business Development</h3>
              <p className="text-blue-100">Comprehensive business growth and development consulting</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-indigo-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Career Coaching</h3>
              <p className="text-blue-100">Professional development and career advancement guidance</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
